import Axios from 'axios'
// import router from '@/router'
// import api from '@/api'
// import Vue from 'vue'

export const axios = Axios.create({
  baseURL: '/',
  responseType: 'json',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

axios.interceptors.response.use(resp => {
  return Promise.resolve(resp)
}, res => {
  // for (let key in res) {
  //   if (res.hasOwnProperty(key)) {
  //     console.log(key, res[key])
  //   }
  // }
  let response = res.response
  if (res.code === 'ECONNABORTED' || (response && response.status === 504)) {
    return Promise.resolve({res, data: {code: 504, message: '请求超时'}})
  }
  if (response && response.status === 404) {
    return Promise.resolve({res, data: {code: 404, message: '请求地址不在了哈'}})
  }
  return Promise.reject(res)
})

export const CancelToken = Axios.CancelToken

export const handleResponse = (resp) => {
  return new Promise((resolve, reject) => {
    // alert(JSON.stringify(resp))
    const data = resp.data
    if (!data) {
      reject(createError(400, '没有数据返回，不满足规范要求，请让后端检测接口返回参数'))
      return
    }
    if (resp.data.code === 504) {
      reject(createError(504, '请求超时'))
      return
    }
    if (resp.data.code === 401) {
      reject(createError(401, resp.data.msg))
      return
    }
    if (resp.data.code === 404) {
      reject(createError(404, resp.data.msg))
      return
    }
    if (resp.data.code === 400) {
      reject(createError(400, 'Bad Request'))
      return
    }
    if (resp.data.code === 403) {
      reject(createError(403, '权限不足'))
      return
    }
    if (data.success !== undefined && !data.success) {
      reject(createError(500, data.msg, data.data))
      return
    }
    resolve(data.data ? data.data : data)
  })
}

// 不需要
export const injectCookies = () => {}

export const createError = (code, message, data = {}) => {
  let err = new Error(message)
  err.code = code
  err.msg = message
  err.data = data
  return err
}



// WEBPACK FOOTER //
// ./src/api/axios.js